/* CS Advertorial v2 — zwevende balk (na de reveal), FAQ-accordeon en linkdoorgifte.

   Bewust géén eventcode. Meten loopt volledig via wetracked.io op de
   standaardevents die Shopify zelf al publiceert: page_viewed (de landing page
   view van deze pagina), product_viewed, product_added_to_cart,
   checkout_started en checkout_completed. Die dekken de hele funnel, dus een
   eigen cs_advertorial_* naast die set voegde niets toe behalve onderhoud —
   en zolang wetracked er niet op abonneert kwam er sowieso niets aan.

   Wat hier wél moet gebeuren is de linkdoorgifte hieronder: zonder fbclid op
   de PDP-link kan Meta de klik later niet aan de bestelling koppelen.
*/
(function () {
  'use strict';

  var BALK_KEY = 'cs-adv2-balk';

  /* Parameters die mee moeten reizen naar de PDP: zonder fbclid kan Meta de
     klik later niet terugkoppelen aan de bestelling. */
  var DOORGEEF = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'fbclid',
    'gclid',
    'gbraid',
    'wbraid',
    'ttclid',
    'twclid',
    'msclkid',
    'epik',
    'ScCid',
    'li_fat_id'
  ];


  /* Bouwt de PDP-URL: eerst wat de bezoeker zelf meebracht, daarna de
     ingestelde UTM's als aanvulling. Wat al in de knop-URL stond wint. */
  function maakUrl(basis, defaults) {
    var url;
    try {
      url = new URL(basis, window.location.origin);
    } catch (e) {
      return basis;
    }

    var binnen;
    try {
      binnen = new URLSearchParams(window.location.search);
    } catch (e) {
      binnen = null;
    }

    if (binnen) {
      DOORGEEF.forEach(function (sleutel) {
        var waarde = binnen.get(sleutel);
        if (waarde && !url.searchParams.has(sleutel)) {
          url.searchParams.set(sleutel, waarde);
        }
      });
    }

    /* Alleen aanvullen als de bezoeker zelf geen bron meebracht, anders
       overschrijf je de echte herkomst met een vaste waarde. */
    if (!url.searchParams.has('utm_source')) {
      Object.keys(defaults).forEach(function (sleutel) {
        if (defaults[sleutel]) {
          url.searchParams.set(sleutel, defaults[sleutel]);
        }
      });
    }

    return url.pathname + url.search + url.hash;
  }

  function initFaq(root) {
    var faq = root.querySelector('[data-cs-adv2-faq]');
    if (!faq) return;

    /* Chrome 120+/Safari 17.2+/Firefox 130+ doen het exclusieve accordeon zelf
       via het name-attribuut. Alleen oudere browsers hebben deze hulp nodig. */
    if ('name' in document.createElement('details')) return;

    var items = Array.prototype.slice.call(faq.querySelectorAll('details'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (ander) {
          if (ander !== item) ander.open = false;
        });
      });
    });
  }

  function initBalk(root) {
    var balk = root.querySelector('[data-cs-adv2-balk]');
    if (!balk) return;

    var gesloten = false;
    try {
      gesloten = sessionStorage.getItem(BALK_KEY) === '1';
    } catch (e) {}

    if (gesloten) {
      balk.remove();
      return;
    }

    var drempel = parseFloat(root.getAttribute('data-balk-drempel'));
    if (!isFinite(drempel) || drempel <= 0) drempel = 30;
    drempel = drempel / 100;

    var diepGenoeg = false;
    var ctaInBeeld = false;
    var afgesloten = false;

    function ververs() {
      balk.classList.toggle('cs-adv2__balk--zichtbaar', !afgesloten && diepGenoeg && !ctaInBeeld);
    }

    /* De balk hoort pas bij de commerciële helft: hij verschijnt zodra het
       Chapter-blok (de reveal) in beeld is geweest. Ontbreekt dat blok, dan
       geldt de oude scrolddiepte als terugval. */
    var reveal = root.querySelector('[data-cs-adv2-reveal]');
    var revealGezien = false;
    if (reveal && 'IntersectionObserver' in window) {
      var revealIo = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          revealGezien = true;
          revealIo.disconnect();
          diepGenoeg = true;
          ververs();
        },
        { threshold: 0.2 }
      );
      revealIo.observe(reveal);
    }

    var ctas = ['adv-reveal', 'adv-cta-1', 'adv-cta-2']
      .map(function (id) {
        return document.getElementById(id);
      })
      .filter(Boolean);

    if (ctas.length && 'IntersectionObserver' in window) {
      var zichtbaar = {};
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            zichtbaar[entry.target.id] = entry.isIntersecting;
          });
          ctaInBeeld = Object.keys(zichtbaar).some(function (id) {
            return zichtbaar[id];
          });
          ververs();
        },
        { threshold: 0.15 }
      );
      ctas.forEach(function (cta) {
        io.observe(cta);
      });
    }

    var sluit = balk.querySelector('[data-cs-adv2-balk-sluit]');
    if (sluit) {
      sluit.addEventListener('click', function () {
        try {
          sessionStorage.setItem(BALK_KEY, '1');
        } catch (e) {}
        /* Afgesloten blijft staan: zonder deze vlag zet de eerstvolgende
           scroll diepGenoeg weer op true en schuift de balk terug in beeld.
           De balk blijft in de DOM zodat hij netjes uitschuift; de CSS haalt
           hem daarna met visibility uit de tabvolgorde. */
        afgesloten = true;
        ververs();
      });
    }

    return function (fractie) {
      /* Met een reveal-blok op de pagina bepaalt dat blok het moment, niet
         de scrolldiepte; daarna blijft de balk staan. */
      if (reveal) {
        if (revealGezien && !diepGenoeg) {
          diepGenoeg = true;
          ververs();
        }
        return;
      }
      var nu = fractie >= drempel;
      if (nu !== diepGenoeg) {
        diepGenoeg = nu;
        ververs();
      }
    };
  }

  function init(root) {
    if (!root || root.dataset.csAdv2Init === '1') return;
    root.dataset.csAdv2Init = '1';

    /* 1. Links: UTM's en klik-ID's doorgeven aan de PDP. */
    var basis = root.getAttribute('data-cta-url') || '/products/sleep-capsules';
    var doel = maakUrl(basis, {
      utm_source: root.getAttribute('data-utm-source'),
      utm_medium: root.getAttribute('data-utm-medium'),
      utm_campaign: root.getAttribute('data-utm-campaign')
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-cs-a2-cta]')).forEach(function (knop) {
      knop.setAttribute('href', doel);
    });

    /* 2. FAQ + zwevende balk. */
    initFaq(root);
    var meldDiepte = initBalk(root);

    /* 3. Scrollpositie voor de drempel van de zwevende balk.

       Staat de balk uit of is hij al weggeklikt, dan geeft initBalk niets
       terug en hoeft er ook niets aan de scroll te hangen.

       De scrollhoogte wordt apart bijgehouden en niet per scroll-event
       opgevraagd: scrollHeight uitlezen dwingt een layout af, en dat wil je
       niet tientallen keren per seconde tijdens het scrollen. De handler zelf
       leest alleen window.scrollY en is daarmee gratis. */
    if (!meldDiepte) return;

    var maxScroll = 0;

    function meetGrenzen() {
      maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    }

    function meet() {
      meldDiepte(maxScroll > 0 ? window.scrollY / maxScroll : 1);
    }

    function herijk() {
      meetGrenzen();
      meet();
    }

    window.addEventListener('scroll', meet, { passive: true });
    window.addEventListener('resize', herijk, { passive: true });
    /* Lazy beelden en late fonts verschuiven de paginahoogte nog na DOMContentLoaded. */
    window.addEventListener('load', herijk);

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(meetGrenzen);
      ro.observe(document.documentElement);
    }

    herijk();
  }

  function start() {
    document.querySelectorAll('[data-cs-adv2]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Theme editor: sectie opnieuw opbouwen na een wijziging. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-cs-adv2]');
    if (root) init(root);
  });
})();
